import { css } from 'styled-components'
import transformProps from '../utils/transformProps'
import { ConfigType, StyleType } from '../utils/transformProps/types'

type ColorKey = 'color'
type FilledColorKeys = 'backgroundColor' | 'tintColor'
type OpacityKeys = 'opacity'
export type ColorKeys = ColorKey | FilledColorKeys | OpacityKeys

type BaseColorProp = {
    [key in ColorKey]?: string
}
type FilledColorProp = {
    [key in FilledColorKeys]?: string | string[]
}
type OpacityProp = {
    [key in OpacityKeys]?: number | number[]
}
export type ColorProps = BaseColorProp & FilledColorProp & OpacityProp

export const colorConfig: ConfigType<ColorKeys> = {
    color: {
        property: ['color'],
        scale: 'colors',
    },
    tintColor: {
        property: ['tintColor'],
        scale: 'colors',
    },
    backgroundColor: {
        property: ['backgroundColor'],
        scale: 'colors',
    },
    opacity: {
        property: ['opacity'],
    },
}

export const color = css<ColorProps>`
    ${(props): StyleType => transformProps(colorConfig, props)}
`
